module.exports = __webpack_public_path__ + "img/ic_app_down.69b6d44c.svg";